var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.6274,
    cy: 22,
    r: 22,
    fill: "#FFEBC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7326 27.1494C-0.747442 28.0294 -0.747442 46.1894 11.7326 47.0694H16.8527",
    stroke: "#395966",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8659 27.1495C3.30589 3.33614 39.4124 -6.18384 43.5457 18.8295C55.0924 20.2962 59.7592 35.6828 51.0125 43.3362C48.3459 45.7628 44.9058 47.0961 41.3058 47.0695H41.0658",
    stroke: "#395966",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2925 41.5765C42.2925 43.5498 41.8658 45.4165 41.0658 47.0698C40.8525 47.5498 40.6126 48.0032 40.3459 48.4298C38.0526 52.2965 33.8125 54.9098 28.9592 54.9098C24.1059 54.9098 19.8658 52.2965 17.5725 48.4298C17.3058 48.0032 17.0659 47.5498 16.8526 47.0698C16.0526 45.4165 15.6259 43.5498 15.6259 41.5765C15.6259 34.2165 21.5992 28.2432 28.9592 28.2432C36.3192 28.2432 42.2925 34.2165 42.2925 41.5765Z",
    stroke: "#395966",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.799 41.5762L27.4389 44.2162L33.1189 38.9629",
    stroke: "#FCBE1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAdd);
export default __webpack_public_path__ + "static/media/cloudAdd.839c9b282052bb2b6b36697f79cad81b.svg";
export { ForwardRef as ReactComponent };